import type { ReactNode } from "react";
import { cn } from "../../lib/cn";
import type { PreviewWarning } from "../../lib/api";

export function SeverityBadge({ severity }: { severity: PreviewWarning["severity"] }) {
  if (severity === "error") return <span className="chip-rose text-[11px]">Error</span>;
  if (severity === "warn") return <span className="chip-amber text-[11px]">Warning</span>;
  return <span className="chip-neutral text-[11px]">Info</span>;
}

export function SubTypeList({ types }: { types?: string[] }) {
  if (!types || types.length === 0) return <span className="text-ash">—</span>;
  return (
    <div className="flex flex-wrap gap-1">
      {types.map((t) => (
        <span key={t} className="chip-brand text-[10.5px]">{t}</span>
      ))}
    </div>
  );
}

export function Pagination({ page, pageCount, onChange }: { page: number; pageCount: number; onChange: (p: number) => void }) {
  return (
    <div className="flex items-center justify-center gap-2 pt-2">
      <button onClick={() => onChange(page - 1)} disabled={page === 0} className="btn-ghost text-[12px] disabled:opacity-40">
        ← Prev
      </button>
      <span className="text-[12px] text-ash">Page {page + 1} of {pageCount}</span>
      <button onClick={() => onChange(page + 1)} disabled={page >= pageCount - 1} className="btn-ghost text-[12px] disabled:opacity-40">
        Next →
      </button>
    </div>
  );
}

export function EmptySection({ label }: { label: string }) {
  return (
    <div className="card px-6 py-12 text-center">
      <p className="text-[13.5px] text-ash">{label}</p>
    </div>
  );
}

export function Th({ children, className }: { children?: ReactNode; className?: string }) {
  return (
    <th className={cn("px-5 py-3 font-mono text-[10.5px] font-semibold uppercase tracking-[0.18em] text-ash", className)}>
      {children}
    </th>
  );
}

export function Td({ children }: { children?: ReactNode }) {
  return <td className="px-5 py-3 align-middle">{children}</td>;
}
